import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from './ui/button'

const NotFoundPage: React.FC = () => {
  return (
    <div className="py-32 px-4">
      <div className="max-w-2xl mx-auto text-center">
        <h1 className="text-5xl font-bold text-blurple mb-6">Welcome to Zoee!</h1>
        <p className="text-xl text-gray-600">Unfortunately the page you're looking for doesn't exist on our platform.</p>
        <p className="text-xl text-gray-600">Please verify that the link or address you entered was correct.</p>
         <p className="text-xl text-gray-600">Best, The Zoee Team ❤️</p>
      </div>
      <div className="flex justify-center mt-8">
        <Button asChild variant="default">
          <Link to="/">
            Take me home
          </Link>
        </Button>
      </div>
    </div>
  )
}

export default NotFoundPage
